/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Route, RouteProps, RouteComponentProps } from 'react-router-dom';

import { useAuth } from '@/features/auth/providers/AuthProvider/hooks';
import { isSessionExpired } from '@/features/auth/providers/AuthProvider/helpers';

import AuthGuard from '@/features/auth/components/AuthGuard';

interface PublicRouteProps extends Omit<RouteProps, 'component'> {
  component: React.ComponentType<RouteComponentProps>;
  restricted?: boolean;
}

const PublicRoute: React.FC<PublicRouteProps> = ({
  component: Component,
  restricted,
  ...rest
}: PublicRouteProps) => {
  const { user, status } = useAuth();

  return (
    <Route
      {...rest}
      render={props => {
        return (
          <AuthGuard
            // Redirect to home if user is logged in and route is restricted
            redirectToIfFails="/"
            canActivate={() =>
              !(restricted && !isSessionExpired(status) && user)
            }
            // Setup auth only for restricted routes
            enabled={restricted}
          >
            <Component {...props} />
          </AuthGuard>
        );
      }}
    />
  );
};

PublicRoute.defaultProps = {
  restricted: false,
};

export default PublicRoute;
